import { createFileRoute } from "@tanstack/react-router";
import { AboutContent } from "@/components/pages/AboutContent";
import { publishedCmsPageQuery } from "@/lib/cms/queries";
import { canonicalUrl } from "@/lib/seo/site";

export const Route = createFileRoute("/about")({
  // Section copy is edited in Admin → CMS Pages → About; prefetching keeps the
  // server and client render identical.
  loader: ({ context }) => context.queryClient.ensureQueryData(publishedCmsPageQuery("about")),
  head: () => ({ meta: [
    { title: "About CB16 — The House, the Atelier, the Craft" },
    { name: "description", content: "The story of CB16 Atelier — a modern maison rooted in the perfumery traditions of the East." },
    { property: "og:title", content: "About CB16" },
    { property: "og:description", content: "The story of CB16 Atelier — a modern maison rooted in the perfumery traditions of the East." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary_large_image" },
    { property: "og:url", content: canonicalUrl("/about") },
  ], links: [{ rel: "canonical", href: canonicalUrl("/about") }] }),
  component: AboutContent,
});